module.exports = __webpack_public_path__ + "static/Coatex-74b232b6701b0a7ed25dbe86b00367c4.png";